// extracted by mini-css-extract-plugin
export default {"dropdownItemContainer":"UserStoryDropdown_dropdownItemContainer__26Jli","boldText":"UserStoryDropdown_boldText__Sd5EX"};